import React from "react";
import SettingsIcon from '@mui/icons-material/Settings'
import GestureIcon from '@mui/icons-material/Gesture';
import SlideInfoApp from "./sidebarTop_apps/slide_info";
import GradingIcon from '@mui/icons-material/Grading';
import NavigationIcon from '@mui/icons-material/Navigation';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import {
	AccountTree,
	BorderColorRounded,
	Class,
	Crop169,
	DisplaySettingsTwoTone,
	ElectricalServicesTwoTone,
	GradientTwoTone,
	Grid3x3,
	Info,
	KeyboardAltRounded,
	ScreenshotTwoTone,
	SettingsSuggestTwoTone,
	SmartToyOutlined,
	StorageTwoTone
} from "@mui/icons-material";
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import {DeepBioIcon, DisplaySettingType, IHCIcon, slideViewerType} from "../../utils/const";

import TileViewApp from "./sidebarTop_apps/TileView";
import AnnotationsApp from "./sidebarTop_apps/annotationsApp";
import BloodAnnotationsApp from "./bloodApps/bloodAnnotationsApp";
import DisplaySettings from "./sidebarTop_apps/DisplaySettings";
import PreviewMap from "./sidebarBottom_apps/preview";
import PreviewIcon from '@mui/icons-material/Preview';
import Barcode from "./sidebarBottom_apps/barcode";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import GridOverlay from "./sidebarTop_apps/GridOverlay";
import Screenshot from "./sidebarTop_apps/Screenshot";
import AiChatApp from "./sidebarTop_apps/aiChatApp";
import Thumbnail from "./sidebarBottom_apps/thumbnail";
import DeepBioApp from "./sidebarTop_apps/deepBioApp";

import CliaApp from "./sidebarTop_apps/cliaApp";
import SlideNavigatorApp from "./sidebarTop_apps/slideNavigatorApp";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import IndxApp from "./sidebarTop_apps/indxApp";

import ZStackControl from "./rightBottom_apps/ZStackControlApp";
import ZoomControl from "./rightBottom_apps/zoomControl";
import ShortcutsApp from "./sidebarTop_apps/Shortcuts";
import IHCApp from "./sidebarTop_apps/IHC";
import LabellingApp from "./sidebarTop_apps/Labelling";
import ConfigurationApp from "./sidebarTop_apps/Configuration";
import CaseInfo from "./sidebarTop_apps/CaseInfo";
import ReportApp from "./sidebarTop_apps/cap_report";
import ServicesApp from "./sidebarTop_apps/ServicesApp";
import ExposureControl from "./rightBottom_apps/ExposureControl";
import DisksApp from "./sidebarTop_apps/DisksApp";
import DisplayCalibration from "./sidebarTop_apps/DisplayCalibration";
import LayersControl from "./rightBottom_apps/LayersControl";
import Lnmets from "./sidebarTop_apps/lnmets";
import {isMobileViewer} from "./utils/map_utils";
import BackgroundBlendApp from "./sidebarTop_apps/backgroundBlendApp";
import {aclPermissions} from "../../const/ACLPermissions";

// Side Bar Top Apps

export const annotationsApp = {
	id: aclPermissions.view_own_annotation,
	drawer: 0,
	component: <AnnotationsApp/>,//send your component
	defaultPermission: true,
	makeSideBarIcon: !isMobileViewer(),// show user without clicking
	icon: <GestureIcon sx={{fontSize: 'inherit'}}/>,// custom mui icon
	title: "Annotations", //will be shown inside all apps section only
	showTitleOnHover: true,//only works if "makeSideBarIcon=true" and title is given
};

const slideInfoApp = {
	id: aclPermissions.slide_info_app,
	component: <SlideInfoApp viewerType={slideViewerType.GAMMA_SLIDE_VIEWER}/>,
	defaultPermission: true,
	makeSideBarIcon: !isMobileViewer(),
	icon: <Info sx={{fontSize: 'inherit'}}/>,
	title: "Slide Info",
	showTitleOnHover: true,
};

export const tileViewApp = {
	id: aclPermissions.tile_view_app,
	drawer: 6,
	component: <TileViewApp viewerType={slideViewerType.GAMMA_SLIDE_VIEWER}/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <CalendarViewMonthIcon sx={{fontSize: 'inherit'}}/>,
	title: "Tile View",
	showTitleOnHover: true,
};

export const caseInfoApp = {
	id: aclPermissions.case_info_app,
	component: <CaseInfo/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <Class sx={{fontSize: 'inherit'}}/>,
	title: "Patient Folder Info",
	showTitleOnHover: true,
};

export const capReport = {
	id: aclPermissions.cap_report_app,
	component: <ReportApp/>,
	defaultPermission: false,
	title: "Cap Report",
};

const DisplaySettingsApp = {
	id: aclPermissions.display_settings_app,
	component: <DisplaySettings type={DisplaySettingType.SLIDE}/>,
	defaultPermission: true,
	makeSideBarIcon: !isMobileViewer(),
	icon: <SettingsIcon sx={{fontSize: 'inherit'}}/>,
	title: "Settings",
	showTitleOnHover: true,
};

export const gridOverlayApp = {
	id: aclPermissions.grid_overlay_app,
	component: <GridOverlay/>,
	defaultPermission: true,
	makeSideBarIcon: false,
	icon: <Grid3x3 sx={{fontSize: 'inherit'}}/>,
	title: "Grid",
	showTitleOnHover: true,
};

export const screenshotApp = {
	id: aclPermissions.screenshot_app,
	component: <Screenshot/>,
	defaultPermission: true,
	makeSideBarIcon: false,
	icon: <ScreenshotTwoTone sx={{fontSize: 'inherit'}}/>,
	title: "Screenshot",
	showTitleOnHover: true,
};

export const aiChatApp = {
	id: aclPermissions.ai_chat_app,
	component: <AiChatApp/>,
	defaultPermission: true,
	makeSideBarIcon: !isMobileViewer(),
	/** Open only as the right-side panel — never the left sidebar drawer. */
	openAsRightPanel: true,
	icon: <SmartToyOutlined sx={{fontSize: 'inherit'}}/>,
	title: "Morpho Chat",
	showTitleOnHover: true,
};

const shortcutsApp = {
	id: aclPermissions.keyboard_shortcuts_app,
	component: <ShortcutsApp/>,
	defaultPermission: true,
	makeSideBarIcon: false,
	icon: <KeyboardAltRounded sx={{fontSize: 'inherit'}}/>,
	title: "Shortcuts",
	showTitleOnHover: true,
};

export const deepBioApp = {
	id: aclPermissions.deep_bio_app,
	drawer: 1,
	component: <DeepBioApp/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <DeepBioIcon sx={{filter: "brightness(100) contrast(100)"}}/>,
	title: "DeepBio",
	showTitleOnHover: true,
};

export const ihcApp = {
	id: aclPermissions.ihc_app,
	drawer: 2,
	component: <IHCApp/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <IHCIcon sx={{fontSize: 'inherit'}}/>,
	title: "IHC",
	showTitleOnHover: true,
};

export const labellingApp = {
	id: aclPermissions.labelling_app,
	component: <LabellingApp/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <BorderColorRounded sx={{fontSize: 'inherit'}}/>,
	title: "Labelling",
	showTitleOnHover: true,
};

const cliaApp = {
	id: aclPermissions.clia_app,
	component: <CliaApp/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <GradingIcon sx={{fontSize: 'inherit'}}/>,
	title: "Clia",
	showTitleOnHover: true,
};

const slideNavigationApp = {
	id: aclPermissions.slide_navigator_app,
	component: <SlideNavigatorApp/>,  //<SlideNavigatorApp />,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <NavigationIcon sx={{fontSize: 'inherit'}}/>,
	title: "Slide Navigator",
	showTitleOnHover: true,
};

const servicesApp = {
	id: aclPermissions.services_app,
	component: <ServicesApp/>,
	defaultPermission: false,
	makeSideBarIcon: false,
	icon: <ElectricalServicesTwoTone sx={{fontSize: 'inherit'}}/>,
	title: "Services",
	showTitleOnHover: true,
};

const disksApp = {
	id: aclPermissions.disks_app,
	component: <DisksApp/>,
	defaultPermission: false,
	makeSideBarIcon: false,
	icon: <StorageTwoTone sx={{fontSize: 'inherit'}}/>,
	title: "Disks",
	showTitleOnHover: true,
};

const getIndxApp = () => {
	return {
		id: aclPermissions.indx_app,
		component: <IndxApp/>,
		defaultPermission: false,
		makeSideBarIcon: false,
		icon: <DriveFileRenameOutlineIcon sx={{fontSize: 'inherit'}}/>,
		title: "Indx",
		showTitleOnHover: true,
	}
}

const getBloodAnnotationsApp = () => {
    return {
        id: aclPermissions.blood_annotations_app,
        component: <BloodAnnotationsApp/>,
        defaultPermission: false,
        makeSideBarIcon: !isMobileViewer(),
        icon: <BloodtypeIcon sx={{fontSize: 'inherit'}}/>,
        title: "Blood Annotations",
        showTitleOnHover: true,
    }
}

export const configurationApp = ({
	id: aclPermissions.configuration_app,
	component: <ConfigurationApp/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <SettingsSuggestTwoTone sx={{fontSize: 'inherit'}}/>,
	title: "Configuration",
	showTitleOnHover: true,
});

export const displayCalibrationApp = ({
	id: aclPermissions.display_calibration_app,
	component: <DisplayCalibration/>,
	defaultPermission: false,
	makeSideBarIcon: false,
	icon: <DisplaySettingsTwoTone sx={{fontSize: 'inherit'}}/>,
	title: "Display Calibration",
	showTitleOnHover: true,
});

// Side Bar Bottom Apps

export const previewApp = {
	id: aclPermissions.preview_controls_app,
	component: <PreviewMap/>,
	defaultPermission: true,
	makeSideBarIcon: true,
	icon: <PreviewIcon sx={{fontSize: 'inherit'}}/>,
	title: "Preview",
	className: "preview-controls-forTour",
	showTitleOnHover: true,
};

const thumbnailViewerApp = {
	id: aclPermissions.thumbnail_app,
	component: <Thumbnail/>,
	defaultPermission: true,
	makeSideBarIcon: true,
	icon: <Crop169 sx={{fontSize: 30}}/>,
	title: "Thumbnail",
	className: "thumbnail-forTour",
	showTitleOnHover: true,
};

export const barcodeApp = {
	id: aclPermissions.barcode_app,
	component: <Barcode/>,
	defaultPermission: true,
	makeSideBarIcon: true,
	icon: <QrCode2Icon sx={{fontSize: 'inherit'}}/>,
	title: "Barcode",
	className: "barcode-forTour",
	showTitleOnHover: true,
};

// HeadBar Apps

export const splitSyncApp = {
	id: aclPermissions.split_sync_app,
	defaultPermission: true,
}

export const caseImage = {
	id: aclPermissions.case_image_app,
	defaultPermission: true,
}

export const editAnnoLabelApp = {
	id: aclPermissions.edit_anno_label_app,
	defaultPermission: true,
}

export const oneToOnePdfApp = {
	id: aclPermissions.one_to_one_pdf_app,
	defaultPermission: true,
}

export const shareLinkApp = {
	id: aclPermissions.share_link,
	defaultPermission: true,
}

export const shareSlideApp = {
	id: aclPermissions.share_slide,
	defaultPermission: false,
}

export const goToPrevNextSlideApp = {
	id: aclPermissions.prev_next_slide_app,
	defaultPermission: true
}

// Right Bottom Apps

const layersControlApp = {
	id: aclPermissions.layers_control_app,
	component: <LayersControl opacity={1}/>,
	defaultPermission: true,
	title: "Layers Control",
	showTitleOnHover: true,
}

const zoomControlApp = {
	id: aclPermissions.zoom_control_app,
	component: <ZoomControl opacity={1}/>,
	defaultPermission: true,
	title: "Zoom Control",
	showTitleOnHover: true,
}

const zStackControlApp = {
	id: aclPermissions.zStack_control_app,
	component: <ZStackControl opacity={1}/>,
	defaultPermission: true,
	title: "Z Stack Control",
	showTitleOnHover: true,
}

const exposureControlApp = {
	id: aclPermissions.exposure_control_app,
	component: <ExposureControl opacity={1}/>,
	defaultPermission: true,
	title: "Exposure Control",
	showTitleOnHover: true,
}

export const metsApp = {
	id: aclPermissions.mets_beta_app,
	component: <Lnmets/>,
	defaultPermission: false,
	makeSideBarIcon: !isMobileViewer(),
	icon: <AccountTree sx={{fontSize: 'inherit'}}/>,
	title: "Lymph Node Metastasis",
	showTitleOnHover: true,
};





// originally made for HTIC (Maximus scanners); wanted the scan boundary to blend with the background
const getBackgroundBlendApp = () => {
    return {
        id: aclPermissions.background_blend_app,
        component: <BackgroundBlendApp />, // send your component
        defaultPermission: false,
        makeSideBarIcon: !isMobileViewer(), // show user without clicking
        icon: <GradientTwoTone sx={{fontSize:'inherit'}}/>, // custom mui icon
        title: "Background Blend", // will be shown inside all apps section only
        showTitleOnHover: true, // only works if "makeSideBarIcon=true" and title is given
    }
}


export const getAllSideBarTopApps = () => {
    // now this should return a list of app components
    return [
	    annotationsApp,
	    DisplaySettingsApp,
	    slideInfoApp,
	    caseInfoApp,
		tileViewApp,
	    gridOverlayApp,
	    screenshotApp,
	    aiChatApp,
	    cliaApp,
	    slideNavigationApp,
	    deepBioApp,
	    ihcApp,
	    servicesApp,
	    disksApp,
	    getIndxApp(),
	    getBloodAnnotationsApp(),
		getBackgroundBlendApp(),
	    labellingApp,
	    shortcutsApp,
	    configurationApp,
	    displayCalibrationApp,
		metsApp,
    ];
}

export const getAllSideBarBottomApps = () => {
	return [
		previewApp,
		thumbnailViewerApp,
		barcodeApp,
	];
}

export const getAllRightBottomApps = () => {
	// app make in row reverse
	return [
		exposureControlApp,
		zStackControlApp,
		zoomControlApp,
		layersControlApp,
	];
}

export const getAllApps = () => {
	return [
		...getAllSideBarTopApps(),
		...getAllSideBarBottomApps(),
		...getAllRightBottomApps(),
	];
}
